import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';

const VITAL_THRESHOLDS: Record<string, { good: number; poor: number }> = {
  LCP: { good: 2500, poor: 4000 },
  INP: { good: 200, poor: 500 },
  CLS: { good: 0.1, poor: 0.25 },
  FCP: { good: 1800, poor: 3000 },
  TTFB: { good: 800, poor: 1800 },
};

function classify(name: string, value: number): 'good' | 'needs-improvement' | 'poor' {
  const t = VITAL_THRESHOLDS[name];
  if (!t) return 'good';
  if (value <= t.good) return 'good';
  if (value <= t.poor) return 'needs-improvement';
  return 'poor';
}

function report(metric: Metric): void {
  const rating = classify(metric.name, metric.value);
  // En dev : trace console pour validation manuelle.
  // En prod : à brancher sur Sentry / Datadog RUM via VITE_RUM_ENDPOINT (post-MVP).
  // eslint-disable-next-line no-console
  console.info(`[web-vitals] ${metric.name} = ${metric.value.toFixed(1)} (${rating})`);
}

export function initWebVitals(): void {
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
